<template>
  <div class="col time-container">
    <label v-if="isMobile">{{$t('message.dateAndTime.time')}}</label>
    <VueCtkDateTimePicker
      :locale="$i18n.locale"
      noLabel="true"
      :noButton="!isMobile"
      noClearButton="true"
      noKeyboard="true"
      minuteInterval="15"
      noShortcuts="true"
      :inline="!isMobile"
      onlyTime="true"
      :format="localeFormat"
      noHeader="true"
      dark="true"
      color="#3fa9f5"
      v-model="inputVal"
      formatted="LT"
      label=""
    />
  </div>
</template>

<script>
export default {
  props: ["value", "valid", "isMobile"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    today() {
      return new Date();
    },
    localeFormat() {
      return this.$i18n.locale == "en" ? "hh:mm a" : "HH:mm"
    }
  },
};
</script>

<style>


@media only screen and (min-width:769px) {
  .time-picker {
    min-height: 307px;
  }
  .time-container {
  width: 50%;
  min-height: 307px;
  flex-grow: 1;
}
}

@media only screen and (max-width: 768px) {
  .time-container {
    width: 100%;
  }
}
</style>
